import { useCallback, useEffect } from "react";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui-kit/base/sheet";

import { ApiConnector } from "../../api/api-connector";
import { RoleSwitcher } from "./role-switcher";

export function DevTools({
  open,
  onOpenChange,
  api,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  api: ApiConnector;
}) {
  const toggle = useCallback(() => onOpenChange(!open), [open, onOpenChange]);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === "F2") {
        e.preventDefault();
        toggle();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [toggle]);

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Dev Tools</SheetTitle>
        </SheetHeader>
        <RoleSwitcher api={api} />
      </SheetContent>
    </Sheet>
  );
}
